import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useAuth } from '../components/auth/AuthProvider';
import { getBedrockClient } from '../utils/bedrockClient';
import { useDynamoUtils } from './DynamoUtilsContext';
import { useSession } from './SessionContext';

const BedrockClientContext = createContext(null);

export const BedrockClientProvider = ({ children }) => {
  const { getBedrockRuntimeClient, user } = useAuth();
  const dynamoUtilsRef = useDynamoUtils();
  const session = useSession();
  const bedrockClientRef = useRef(null);

  useEffect(() => {
    const init = async () => {
      if (!user) return;
      const runtime = await getBedrockRuntimeClient();
      if (runtime) {
        bedrockClientRef.current = getBedrockClient({
          client: runtime,
          dynamoUtilsRef,
          session,
        });
      }
    };
    init();
  }, [user, getBedrockRuntimeClient, dynamoUtilsRef, session]);

  return (
    <BedrockClientContext.Provider value={bedrockClientRef}>
      {children}
    </BedrockClientContext.Provider>
  );
};

export const useBedrockClient = () => useContext(BedrockClientContext);
